import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import selectIsModalOpened from '../../../core/selectors/modal';
import LoginModalContent from './LoginModalContent';
import { closeModal } from '../../../core/actions/modal';
import { LOGIN_MODAL_NAME } from '../../constants/modal';
import { SELL_STEP_1 } from '../../constants/steps';

const LoginModal = ({ goToNextStep }) => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => selectIsModalOpened(state, LOGIN_MODAL_NAME));
    const onClose = () => dispatch(closeModal(LOGIN_MODAL_NAME));
    return (
        <Modal show={isOpen} onHide={onClose} className="loginModal modal-fullscreen-sm-down">
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <LoginModalContent goToNextStep={goToNextStep} targetPath={`/sell/${SELL_STEP_1}`}/>
            </Modal.Body>
        </Modal>
    );
};

export default LoginModal;
